import ApplicationStoreIcon from "./ApplicationStoreIcon";

export default ApplicationStoreIcon;